import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";
import { useLang } from "../i18n";

export const EditorialMarquee = () => {
  const { t } = useLang();
  return (
    <div data-testid="editorial-marquee" className="border-y border-white/10 bg-[#070707] py-6">
      <Marquee speed={35} gradient={false} pauseOnHover>
        {t.marquee.map((item, i) => (
          <span key={i} className="mx-6 flex items-center gap-6 font-display text-2xl md:text-4xl uppercase tracking-widest text-neutral-600">
            {item}
            <Asterisk className="text-[#FF5A00]" size={26} />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
